import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import { MarketmanagerAdminModule } from '../../admin/admin.module';
import {
    MarketdateBoothService,
    MarketdateBoothPopupService,
    MarketdateBoothComponent,
    MarketdateBoothDetailComponent,
    MarketdateBoothDialogComponent,
    MarketdateBoothPopupComponent,
    MarketdateBoothDeletePopupComponent,
    MarketdateBoothDeleteDialogComponent,
    marketdateBoothRoute,
    marketdateBoothPopupRoute,
} from './';

const ENTITY_STATES = [
    ...marketdateBoothRoute,
    ...marketdateBoothPopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        MarketmanagerAdminModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        MarketdateBoothComponent,
        MarketdateBoothDetailComponent,
        MarketdateBoothDialogComponent,
        MarketdateBoothDeleteDialogComponent,
        MarketdateBoothPopupComponent,
        MarketdateBoothDeletePopupComponent,
    ],
    entryComponents: [
        MarketdateBoothComponent,
        MarketdateBoothDialogComponent,
        MarketdateBoothPopupComponent,
        MarketdateBoothDeleteDialogComponent,
        MarketdateBoothDeletePopupComponent,
    ],
    providers: [
        MarketdateBoothService,
        MarketdateBoothPopupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerMarketdateBoothModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-booth/marketdate-booth.module.ts